import { render } from "./package-list.vue?vue&type=template&id=dba3b1ee&scoped=true"
import script from "./package-list.ts?vue&type=script&lang=ts"
export * from "./package-list.ts?vue&type=script&lang=ts"

import "./package-list.css?vue&type=style&index=0&id=dba3b1ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dba3b1ee"

export default script